export default __webpack_public_path__ + "static/media/category_02.b697564b.png";